import routes from 'core/routes';

import SessionUser from 'stores/Session/SessionUser';

export const risksRegisterPath = (user: SessionUser | null | undefined): string =>
  user?.risksAssessmentsModuleEnabled ? routes.dashboard.risks.riskRegister : routes.dashboard.risks.toString();
